<template>
  <Modal v-model="visible" title="修改分日预算" width="680">
    <Spin size="large" fix v-if="loading" />
    <Table border :columns="columns" :data="data"> </Table>
    <span class="c-tips">仅支持输入自然数。若预算设置为 <ins>0</ins> 即为不限</span>
    <template slot="footer">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" :loading="loading" @click="ok">
        <span v-if="loading">提交中</span>
        <span v-else>确定</span>
      </Button>
    </template>
  </Modal>
</template>
<script>
import { modifyBudget } from '@/api/convert.model'
import { deepCopy } from '@/common/js/utils'
export default {
  name: 'batchBudget',
  props: {
    value: {
      type: Boolean
    },
    type: {
      type: Number
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    },
    account: {
      type: [Number, String]
    },
    id: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    ok() {
      const { mon, tue, wed, thur, fri, sat, sun } = deepCopy(this.data).pop()
      const param = { ad_account_id: this.account, bizType: this.type, budget_schedule: [mon, tue, wed, thur, fri, sat, sun] }
      if (this.type < 4 && !this.id) {
        this.$Message.error('未传入id值')
        return
      }
      if (this.type === 1) Object.assign(param, { adGroupId: this.id })
      else if (this.type === 2) Object.assign(param, { adId: this.id })

      this.loading = true
      modifyBudget(param)
        .then((data) => {
          this.loading = false
          if (data) {
            this.$emit('input', false)
            this.$emit('refresh')
          }
        })
        .catch((err) => {
          console.error(err)
          this.loading = false
        })
    }
  },
  data() {
    return {
      loading: null
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .ivu-table-wrapper {
  margin-bottom: 12px;
}

::v-deep .ivu-table-cell {
  padding: 0;
}

.c-tips {
  font-size: 14px;
  color: #666;
  line-height: 22px;

  ins {
    color: red;
  }
}
</style>
